module.exports = __webpack_public_path__ + "img/message_praise@2x.c1c34abb.png";